var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _radialGradient2, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _radialGradient3, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNightTimeClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 215.8434307844,
    cy: 185.72557,
    gradientUnits: "userSpaceOnUse",
    r: 336.6901399656
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b395f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3952,
    stopColor: "#39375d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    stopColor: "#323154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8179,
    stopColor: "#262846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9849,
    stopColor: "#151a32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#131830"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131830",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8421,
    stopColor: "#131830"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 455.7338052348,
    x2: 295.7948753346,
    xlinkHref: "#b",
    y1: 505.0191471964,
    y2: 345.0802172962
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 476.6603585404,
    x2: 388.9562267374,
    xlinkHref: "#b",
    y1: 218.555827244,
    y2: 130.851695441
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 185.9712297134,
    cy: 93.8209281568,
    gradientUnits: "userSpaceOnUse",
    r: 313.8366587732
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3473,
    stopColor: "#e9f5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#dff0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8666,
    stopColor: "#cee7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#c2e0ff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#bfdcfd",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9eb2e7"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 385.789154004,
    x2: 431.0262808928,
    xlinkHref: "#f",
    y1: 303.3452723044,
    y2: 166.8669956222
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 334.0382800026,
    x2: 392.1993967584,
    xlinkHref: "#f",
    y1: 209.9780164994,
    y2: 123.7451323874
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 215.5650432138,
    x2: 215.5650432138,
    xlinkHref: "#f",
    y1: 209.5313716016,
    y2: 69.4910792712
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: 126.700979932,
    x2: 34.8885985206,
    xlinkHref: "#f",
    y1: 302.0378646838,
    y2: 215.2676815174
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#f",
    y1: 321.7299954982,
    y2: 427.7742763582
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 368.6634493904,
    cy: 84.9238702162,
    gradientUnits: "userSpaceOnUse",
    r: 90.9009206276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ecf7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2e0ff"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    gradientUnits: "userSpaceOnUse",
    x1: 247.6353315038,
    x2: 136.6432210668,
    xlinkHref: "#f",
    y1: 425.355727868,
    y2: 314.363617431
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0 141.386719-114.613281 256-256 256s-256-114.613281-256-256 114.613281-256 256-256 256 114.613281 256 256zm0 0",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m506.386719 309.488281-132.875-132.878906c-9.875-11.40625-24.453125-18.632813-40.726563-18.632813-10.945312 0-21.121094 3.277344-29.617187 8.886719-.4375-.417969-.875-.839843-1.320313-1.253906-1.765625-1.898437-3.597656-3.738281-5.503906-5.503906-1.765625-1.898438-3.59375-3.738281-5.5-5.5-18.769531-20.179688-45.542969-32.816407-75.277344-32.816407-56.78125 0-102.8125 46.03125-102.8125 102.8125 0 .347657.007813.695313.011719 1.042969-36.070313 6-63.574219 37.347657-63.574219 75.121094 0 22.433594 9.703125 42.597656 25.132813 56.535156l38.511719 38.511719c.695312.769531 1.40625 1.511719 2.128906 2.25-.074219.773438-.121094 1.554688-.121094 2.351562 0 8.140626 3.992188 15.347657 10.117188 19.777344l88.226562 88.226563c13.921875 2.34375 28.222656 3.582031 42.8125 3.582031 123.039062 0 225.789062-86.808594 250.386719-202.511719zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-28.476562-4.65625-55.863281-13.238281-81.449219l-75.46875-75.472656c-6.34375-7.28125-15.675781-11.886719-26.089844-11.886719-16.222656 0-29.832031 11.164063-33.574219 26.230469-1.988281-.59375-4.09375-.917969-6.277344-.917969-12.117187 0-21.941406 9.824219-21.941406 21.941406 0 6.921876 3.207032 13.089844 8.210938 17.113282l161.902344 161.898437c4.234374-18.46875 6.476562-37.699219 6.476562-57.457031zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m386.644531 224.601562c-.515625 0-1.027343.011719-1.542969.019532 1-4.101563 1.542969-8.378906 1.542969-12.789063 0-29.742187-24.113281-53.855469-53.859375-53.855469-11.699218 0-22.519531 3.742188-31.351562 10.078126-18.390625-27.867188-49.980469-46.265626-85.871094-46.265626-56.78125 0-102.808594 46.03125-102.808594 102.8125 0 .347657.007813.695313.011719 1.042969-36.070313 6-63.574219 37.347657-63.574219 75.121094 0 42.066406 34.101563 76.164063 76.164063 76.164063h261.289062c42.0625 0 76.164063-34.097657 76.164063-76.164063 0-42.0625-34.101563-76.164063-76.164063-76.164063zm0 0",
    fill: "url(#e)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m462.808594 300.765625c0 42.066406-34.101563 76.164063-76.164063 76.164063-42.066406 0-76.164062-34.097657-76.164062-76.164063 0-42.0625 34.097656-76.164063 76.164062-76.164063 42.0625 0 76.164063 34.101563 76.164063 76.164063zm0 0",
    fill: "url(#g)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m386.644531 211.832031c0 29.746094-24.113281 53.855469-53.859375 53.855469-29.742187 0-53.855468-24.109375-53.855468-53.855469 0-29.742187 24.113281-53.855469 53.855468-53.855469 29.746094 0 53.859375 24.113282 53.859375 53.855469zm0 0",
    fill: "url(#h)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m318.375 224.601562c0 56.78125-46.027344 102.8125-102.808594 102.8125s-102.8125-46.03125-102.8125-102.8125 46.03125-102.8125 102.8125-102.8125 102.808594 46.03125 102.808594 102.8125zm0 0",
    fill: "url(#i)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m201.519531 300.765625c0 42.066406-34.097656 76.164063-76.164062 76.164063-42.0625 0-76.164063-34.097657-76.164063-76.164063 0-42.0625 34.101563-76.164063 76.164063-76.164063 42.066406 0 76.164062 34.101563 76.164062 76.164063zm0 0",
    fill: "url(#j)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m49.898438 311.140625c5.058593 37.15625 36.914062 65.789063 75.457031 65.789063h261.289062c38.546875 0 70.398438-28.632813 75.457031-65.789063zm0 0",
    fill: "url(#k)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m431.796875 122.074219c0-.09375.003906-.1875.003906-.285157 0-19.105468-15.488281-34.597656-34.597656-34.597656-16.222656 0-29.832031 11.167969-33.574219 26.230469-1.988281-.59375-4.09375-.914063-6.277344-.914063-12.117187 0-21.941406 9.824219-21.941406 21.941407 0 12.117187 9.824219 21.941406 21.941406 21.941406h70.96875c9.570313 0 17.332032-7.761719 17.332032-17.332031 0-8.382813-5.949219-15.375-13.855469-16.984375zm0 0",
    fill: "url(#l)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m265.761719 376.929688-3.972657-3.972657c-5.640624-6.09375-13.707031-9.914062-22.667968-9.914062-.105469 0-.207032.011719-.3125.011719-.0625-.058594-.121094-.121094-.183594-.179688l-20.382812-20.382812c-8.867188-9.285157-21.359376-15.078126-35.210938-15.078126-26.894531 0-48.699219 21.800782-48.699219 48.695313 0 .136719.011719.269531.011719.398437-.582031.121094-1.152344.265626-1.714844.421876zm0 0",
    fill: "url(#m)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNightTimeClouds);
export default __webpack_public_path__ + "static/media/icon-night-time-clouds.db35fb776426875e5eae526e248d2f98.svg";
export { ForwardRef as ReactComponent };